import styled from "styled-components";

export const MapTypeContent = styled.div`
  position: absolute;
  z-index: 1000;
  bottom: 0.7rem;
  left: 0.7rem;
`;

export const LegendContent = styled.div`
  position: absolute;
  z-index: 1000;
  top: 6rem;
  left: 0.7rem;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const LegendTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 42px;
  height: 42px;
  border-radius: 50%;

  background-color: rgb(255 255 255 / 90%);
  box-shadow: 0 2px 8px rgb(0 0 0 / 15%);

  cursor: pointer;
  transition:
    background-color 0.25s ease,
    transform 0.25s ease,
    box-shadow 0.25s ease;

  &:hover {
    background-color: rgb(245 245 245 / 100%);
    transform: scale(1.08);
    box-shadow: 0 4px 12px rgb(0 0 0 / 20%);
  }

  svg {
    transition: transform 0.3s ease;
    transform: rotate(${({ $open }) => ($open ? "360deg" : "0deg")});
  }
`;

export const LegendBody = styled.div`
  display: grid;
  grid-template-rows: ${({ $open }) => ($open ? "1fr" : "0fr")};
  opacity: ${({ $open }) => ($open ? 1 : 0)};

  width: 11.5rem;
  margin-top: ${({ $open }) => ($open ? "0.5rem" : "0")};

  background-color: rgb(255 255 255 / 88%);
  border-radius: 12px;

  visibility: ${({ $open }) => ($open ? "visible" : "hidden")};

  transition:
    grid-template-rows 0.4s ease-in-out,
    opacity 0.25s ease-in-out,
    margin-top 0.4s ease-in-out,
    visibility 0.4s;

  > .inner {
    min-height: 0;
    overflow: hidden;
  }
`;
export const LegendsRightContainer = styled.div`
  position: absolute;
  z-index: 1000;
  top: 1rem;
  right: 0.7rem;

  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;
`;

export const LegendContentRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
export const LegendBodyRight = styled.div`
  display: grid;
  grid-template-rows: ${({ $open }) => ($open ? "1fr" : "0fr")};
  opacity: ${({ $open }) => ($open ? 1 : 0)};

  width: 18rem;
  margin-top: ${({ $open }) => ($open ? "0.5rem" : "0")};

  background-color: rgb(255 255 255 / 88%);
  border-radius: 12px;

  visibility: ${({ $open }) => ($open ? "visible" : "hidden")};

  transition:
    grid-template-rows 0.4s ease-in-out,
    opacity 0.25s ease-in-out,
    margin-top 0.4s ease-in-out,
    visibility 0.4s;

  > .inner {
    min-height: 0;
    overflow: hidden;
  }
`;
export const EquipmentSelector = styled.div`
  position: absolute;
  z-index: 1000;
  top: 0.7rem;
  right: 0.7rem;
  background-color: rgb(255 255 255 / 88%);
  width: 13.5rem;
  padding: 0.5rem;
`;

export const ViewFilterContent = styled.div`
  position: absolute;
  z-index: 2000;
  top: 0.7rem;
  right: 0.7rem;
  background-color: rgb(255 255 255 / 88%);
  width: 11rem;
  padding: 0.3rem;
`;
export const LegendContentTopLeft = styled.div`
  position: absolute;
  z-index: 1000;
  top: 0.7rem;
  left: 3.5rem;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  background-color: rgb(255 255 255 / 88%);
  border-radius: 25px;

  width: 3rem;
  overflow: hidden;
  white-space: nowrap;

  transition: width 0.4s ease-in-out;

  &:hover {
    width: 35rem;
  }

  .legend-options {
    display: flex;
    align-items: center;
    opacity: 0;
    transition: opacity 0.25s ease-in-out;
    transition-delay: 0s;
  }

  &:hover .legend-options {
    opacity: 1;
    transition-delay: 0.15s;
  }
`;
